import {StyleSheet} from "aphrodite";
import * as React from "react";
import {Redirect} from "react-router-dom";

import {View} from "@khanacademy/wonder-blocks-core";
import {CircularSpinner} from "@khanacademy/wonder-blocks-progress-spinner";

import PageRoot from "#app-shell-package/page-root.tsx";
import HeaderOnlyPageTemplate from "#app-shell-package/page-templates/header-only-page-template.tsx";

import * as urls from "../lib/urls.ts";
import {useIsDigitalSatStudent} from "../lib/use-is-digital-sat-student.ts";

function DigitalSatStartRedirectPageContainer(): React.ReactElement {
    // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'IsSatStudentResult'.
    const {status, value: isDigitalSatStudent} = useIsDigitalSatStudent();

    return (
        <PageRoot template={HeaderOnlyPageTemplate}>
            {status === "loading" ? (
                <View style={styles.container}>
                    <CircularSpinner style={styles.spinner} />
                </View>
            ) : (
                <Redirect
                    to={
                        isDigitalSatStudent
                            ? urls.digitalSatTarget
                            : urls.digitalSatLandingPage({confirmed: false})
                    }
                />
            )}
        </PageRoot>
    );
}

export default DigitalSatStartRedirectPageContainer;

const styles = StyleSheet.create({
    spinner: {
        alignSelf: "center",
    },

    container: {
        backgroundColor: "#eee",
        height: "100%",
        justifyContent: "center",
    },
});
